import React from "react";
import { TrendingUp, Crosshair, Shield, ArrowUpRight } from "lucide-react";

const DIVISIONS = [
  {
    key: "growth",
    no: "01",
    icon: TrendingUp,
    title: "CAMO Growth",
    desc: "Increase visibility, influence and digital presence through strategic growth operations.",
    services: [
      "Reach & Visibility",
      "Content Amplification",
      "Brand Development",
      "Strategic Growth",
    ],
  },
  {
    key: "intelligence",
    no: "02",
    icon: Crosshair,
    title: "CAMO Intelligence",
    desc: "Information drives decisions.",
    services: [
      "Open-Source Intelligence",
      "Due Diligence",
      "Strategic Analysis",
      "Business Verification",
    ],
  },
  {
    key: "protection",
    no: "03",
    icon: Shield,
    title: "CAMO Protection",
    desc: "Protect what matters.",
    services: [
      "Reputation Protection",
      "Crisis Management",
      "Digital Security",
      "Risk Mitigation",
    ],
  },
];

export const Divisions = () => {
  return (
    <section
      id="divisions"
      data-testid="divisions-section"
      className="relative bg-black text-white py-24 md:py-32 lg:py-40 border-t border-zinc-900"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-16 md:mb-24">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-zinc-600" />
              <span className="font-mono text-[10px] md:text-xs tracking-[0.4em] uppercase text-zinc-400">
                Our Divisions
              </span>
            </div>
            <h2 className="font-display font-light uppercase leading-[1] tracking-tight text-4xl sm:text-5xl md:text-6xl">
              Three Pillars<br />of Operation
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 flex items-end">
            <p className="font-sans text-base md:text-lg leading-relaxed text-zinc-400">
              A unified framework — three distinct disciplines operating in
              concert. Each division is engineered for autonomous excellence,
              and coordinated impact.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-zinc-900">
          {DIVISIONS.map(({ key, no, icon: Icon, title, desc, services }) => (
            <article
              key={key}
              data-testid={`division-card-${key}`}
              className="group relative bg-black p-8 md:p-10 hover:bg-zinc-950 transition-colors duration-500 min-h-[520px] flex flex-col"
            >
              <div className="flex items-start justify-between mb-12">
                <span className="font-mono text-[10px] tracking-[0.4em] uppercase text-zinc-500">
                  {no} / 03
                </span>
                <Icon
                  size={28}
                  strokeWidth={1}
                  className="text-white opacity-70 group-hover:opacity-100 transition-opacity"
                />
              </div>

              <h3 className="font-display font-light text-3xl md:text-4xl leading-tight uppercase tracking-tight">
                {title}
              </h3>

              <p className="mt-5 font-sans text-sm md:text-base text-zinc-400 leading-relaxed">
                {desc}
              </p>

              <ul className="mt-10 pt-6 border-t border-zinc-900 space-y-3 flex-1">
                {services.map((s) => (
                  <li
                    key={s}
                    className="flex items-center gap-3 font-mono text-[11px] tracking-[0.2em] uppercase text-zinc-300"
                  >
                    <span className="h-px w-4 bg-zinc-600" />
                    {s}
                  </li>
                ))}
              </ul>

              <div className="mt-8 flex items-center gap-2 font-mono text-[10px] tracking-[0.4em] uppercase text-zinc-500 group-hover:text-white transition-colors">
                Learn More
                <ArrowUpRight
                  size={14}
                  className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Divisions;
